"use client"

import { ModelShowcaseItemDto } from "api"
import { Badge, HeaderWrap, ModelName, Subtitle } from "./modelShowcase.styled"

type Props = { model: ModelShowcaseItemDto }

const ModelHeader = ({ model }: Props) => (
  <HeaderWrap>
    <Badge dir="auto">{model.badgeText}</Badge>
    {model.modelName && <ModelName dir="auto">{model.modelName}</ModelName>}
    {model.modelSubtitle && (
      <Subtitle dir="auto">{model.modelSubtitle}</Subtitle>
    )}
  </HeaderWrap>
)

export default ModelHeader
